// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style-module--arrow--2y48v","arrow__wrapper":"style-module--arrow__wrapper--3XxWM","arrowScroll":"style-module--arrow-scroll--3Hh6T"};